import * as React from "react";
import { Link } from "react-router-dom";
import { viewDate } from "src/common/dateTime";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ZDemoData } from "./data/demoDataTypes";

export const demoColumns: RtColumn<ZDemoData>[] = [
  {
    key: "id",
    title: "Id",
    render: (row) => row.id,
    minWidth: 80,
    width: 90,
  },
  {
    key: "name",
    title: "Name",
    sort: true,
    render: (row) => <Link to={makeUrl(PageUrl.cardDemo)}>{row.name}</Link>,
  },
  {
    key: "country",
    title: "Country",
    sort: true,
    render: (row) => row.country.label,
  },
  {
    key: "count",
    title: "Count",
    sort: true,
    render: (row) => row.count,
  },
  {
    key: "beginDate",
    title: "Дата начала",
    sort: true,
    minWidth: 132,
    render: (row) => viewDate(row.beginDate),
  },
];
